<template lang="pug">
.c-form__form-row.c-form__form-row--full
  label.c-form__form-label(v-if="sameCurrentInbox", for="actions") ACCIONES
  #actions.actions--buttons
    .actions--group(v-if="currentProfile == 'BROKER'")
      button.button.is-primary.has-text-weight-light(
        type="button",
        v-for="button in buttons.broker",
        :class="{ active: activeButton == button.action }",
        v-show="showButton(button.action)",
        @click="action(button.action)"
      ) {{ button.name }}
    .actions--group(v-else-if="currentProfile == 'EXECUTIVE'")
      button.button.is-primary.has-text-weight-light(
        type="button",
        v-for="button in buttons.executive",
        :class="{ active: activeButton == button.action }",
        v-show="showButton(button.action)",
        @click="action(button.action)"
      ) {{ button.name }}
    .actions--group(v-else-if="currentProfile == 'TECHNICAL'")
      button.button.is-primary.has-text-weight-light(
        type="button",
        v-for="button in buttons.technical",
        :class="{ active: activeButton == button.action }",
        v-show="showButton(button.action)",
        @click="action(button.action)"
      ) {{ button.name }}
    .actions--group(v-else-if="currentProfile == 'REINSURANCE'")
      button.button.is-primary.has-text-weight-light(
        type="button",
        :class="{ active: activeButton == 'reply' }",
        v-show="showButton('reply')",
        @click="action('reply')"
      ) RESPONDER
</template>

<script>
import SiteConfig from "../services/positiva";
import { isBroker, isExecutive, isTechnical } from "../mixins/user";

const QuotationInbox = {
  BROKER: 1,
  EXECUTIVE: 2,
  TECHNICAL: 3,
};

const QuotationState = {
  PENDING: 1,
  ACCEPTED: 2,
  QUOTED: 3,
  DESISTED: 4,
  REJECTED: 5,
}
export default {
  name: "AppQuotationActions",
  props: {
    status: Number,
    answer: String,
    currentInbox: Number,
    tecnicaQuotation: Object,
    technicalGaveBack: Boolean,
    hasTechnicalQuote: Boolean
  },

  data() {
    return {
      activeButton: null,
      currentProfile: "",
      storedData: {},
      buttons: {
        broker: [
          { name: "RESPONDER", action: "replyExecutive" },
          //{ name: "ACEPTAR", action: "accept" },
          { name: "GANADA", action: "accept" }, 
          //{ name: "DESISTIR", action: "desist" },
          { name: "NO GANADA", action: "desist" },
        ],
        executive: [
          { name: "A BROKER", action: "replyBroker" },
          { name: "A TECNICA", action: "derive" },
          { name: "COTIZAR", action: "quote" },
          { name: "RECHAZAR", action: "reject" },
          //{ name: "ACEPTAR", action: "accept" },
          { name: "GANADA", action: "accept" },
          //{ name: "DESISTIR", action: "desist" },
          { name: "NO GANADA", action: "desist" },
          //{ name: "REENVIAR COTIZACIÓN", action: "forward" },
          { name: "ENVIAR A BROKER", action: "forward" },
          { name: "RECOTIZAR", action: "requote" },
        ],
        technical: [
          { name: "A COMERCIAL", action: "reply" },
          { name: "COTIZAR", action: "quoteTecnica" },
          { name: "RECHAZAR", action: "technicalReject" },
        ],
      },
    };
  },

  mounted() {
    this.storedData = SiteConfig.GetSession();
    if (this.storedData) this.currentProfile = this.storedData.user.profile;
    //console.log(this.currentProfile, "current")
  },

  computed: {
    sameCurrentInbox() {
      let value = null;
      isBroker()
        ? (value = !!(this.currentInbox === QuotationInbox["BROKER"]))
        : null;
      isExecutive()
        ? (value =
            !!(this.currentInbox === QuotationInbox["EXECUTIVE"]) &&
            [1].includes(this.status))
        : null;
      isTechnical()
        ? (value = !!(this.currentInbox === QuotationInbox["TECHNICAL"]))
        : null;
      return value
    },
  },

  methods: {
    showButton(action) {
      switch (action) {
        case "replyBroker":
          return (
            [QuotationInbox.EXECUTIVE].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status) && !this.hasTechnicalQuote && this.technicalGaveBack
          );
        case "replyExecutive":
          return [QuotationInbox.BROKER].includes(this.currentInbox);
        case "reply":
          return (
            [QuotationInbox.TECHNICAL].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status)
          );
        case "accept":
          return [QuotationInbox.BROKER].includes(this.currentInbox);
        case "desist":
          return [QuotationInbox.BROKER].includes(this.currentInbox);
        case "reject":
          return (
            [QuotationInbox.EXECUTIVE].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status)
          );
        case "technicalReject":
          return (
            [QuotationInbox.TECHNICAL].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status)
          );
        case "quote":
          return (
            [QuotationInbox.EXECUTIVE].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status) &&
            !this.tecnicaQuotation && !this.technicalGaveBack
          );
        case "requote":
          return(
            ([QuotationState.REJECTED].includes(this.status) ||
            [QuotationState.DESISTED].includes(this.status) || 
            [QuotationInbox.BROKER].includes(this.currentInbox)) && this.technicalGaveBack
          )
        case "forward":
          return (
            [QuotationInbox.EXECUTIVE].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status) &&
            this.hasTechnicalQuote
          );
        case "quoteTecnica":
          return (
            [QuotationInbox.TECHNICAL].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status)
          );
        case "derive":
          return (
            ([QuotationInbox.EXECUTIVE].includes(this.currentInbox) &&
            [QuotationState.PENDING].includes(this.status)) || [QuotationInbox.BROKER].includes(this.currentInbox) && this.technicalGaveBack && ![QuotationInbox.BROKER].includes(this.currentInbox)
          );
      }
    },

    action(action) {
      this.activeButton = action;
      this.$emit(action);
      this.$emit("changeActionButton")
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
@import "../assets/scss/breakpoints.scss";
.forward-button {
  background-color: $green;
  border-radius: 4px;
  color: white;
  &:hover {
    background-color: $hover-green;
    border-color: transparent;
    color: white;
  }
}
.buttonfinale {
  border-radius: 0;
  cursor: pointer;

  &--action {
    background-color: $hover-green;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 white;
    color: white;
    font-size: 12px;
    font-family: "miraimedium";
  }

  &.active {
    background-color: $green;
    color: white;
  }
}

.actions--buttons {
  .actions--group {
    display: flex;
    justify-content: space-between;
    @include mobile {
      display: flex;
      flex-direction: column;
    }
    width: 100%;
  }

  .button:not(:last-child) {
    @include desktop {
      margin-right: 0.5em;
    }
  }
}

button {
  @include mobile {
    margin-bottom: 1em;
    min-width: 100%;
    height: 70px !important;
  }
}
</style>
